import { ThemeWrapper } from "@verity/components";
import { PropsWithChildren } from "react";
import styles from "./InterviewLayout.module.css";

export default function InterviewPageLayout({ children }: PropsWithChildren) {
	return (
		<ThemeWrapper scoped={false}>
			<div className={styles.pageWrapper}>
				<div className={styles.pageContainer}>{children}</div>
			</div>
		</ThemeWrapper>
	);
}
